module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"termCond":"I have read and agreed to the above Terms and Conditions for Use of ESH, Privacy Policy Statement for ESH and Personal Information Collection Statement.","termCondTitle":"Terms and Conditions"},"zh_hk":{"termCond":"我已閱讀並同意上述使用條款及細則，隱私政策，及個人資料收集聲明。","termCondTitle":"條款與協議"},"zh_cn":{"termCond":"我已阅读并同意上述使用条款及细则，隐私政策，及个人资料收集声明。","termCondTitle":"条款与协议"}}')
  delete Component.options._Ctor
}
